module.exports = __webpack_public_path__ + "img/sync.69a3fdb3.svg";